/**
 * Lightweight inline SVG marks for each MCP host we support.
 *
 * Kept as simple geometry rather than the licensed brand logos so we can
 * tint them with `currentColor` and keep the bundle small. They read as
 * "Cursor / VS Code / Claude" enough to anchor the buttons visually
 * without dragging in third-party logo files.
 */

import type { SVGProps } from 'react';

export function CursorLogo(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
      {...props}
    >
      <path d="M11.7 1.49l9.5 5.49a1 1 0 01.5.86v8.32a1 1 0 01-.5.86l-9.5 5.49a1 1 0 01-1 0L1.2 17.02a1 1 0 01-.5-.86V7.84a1 1 0 01.5-.86L10.7 1.49a1 1 0 011 0zm-.5 2.16L3 8.39 11.2 13l8.2-4.61-8.2-4.74zM2.5 9.74v6l8.2 4.74V14.47L2.5 9.74zm17.4 0L11.7 14.47v6l8.2-4.74v-6z" />
    </svg>
  );
}

export function VSCodeLogo(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
      {...props}
    >
      <path d="M17.42 1.5a1.43 1.43 0 011.29.07l3.93 1.89c.4.19.66.59.66 1.04v15a1.15 1.15 0 01-.66 1.04l-3.93 1.89a1.45 1.45 0 01-1.66-.27L8.7 14.34l-4.4 3.34a.96.96 0 01-1.23-.05l-1.06-.96A.97.97 0 012 15.94V8.06c0-.27.11-.53.31-.73l1.06-.96a.96.96 0 011.23-.05l4.4 3.34 8.35-7.82a1.43 1.43 0 01.07-.34zm.92 6.06L11.95 12l6.39 4.44V7.56zM4.78 12L7.6 9.84 5.22 12l2.38 2.16L4.78 12z" />
    </svg>
  );
}

export function ClaudeLogo(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
      {...props}
    >
      <path d="M12 2c5.52 0 10 4.48 10 10 0 1.6-.38 3.11-1.05 4.45l1.05 4.55-4.55-1.05A9.96 9.96 0 0112 22C6.48 22 2 17.52 2 12S6.48 2 12 2zm-2.4 6.5l-2.6 7h1.7l.6-1.65h2.6L12.5 15.5h1.7l-2.6-7H9.6zm4.85 0v7h1.6V8.5h-1.6zm-3.95 1.7l.95 2.5h-1.9l.95-2.5z" />
    </svg>
  );
}
